import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import { colors } from 'styles';
import SubIntroBackground from 'components/pages/Solution/Marketing/SubIntroBackground';
import SliderBlock from 'components/pages/Solution/Marketing/SliderBlock/SliderBlock';
import Content from 'components/basics/Content';

const Container = styled.div`
  width: 50vw;
  ${breakpoint.down('md')`
    width: 100vw;
  `}
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Text = styled.div`
  ${breakpoint.down('sm')`padding: 1em;`};
`;

const StyledTypography = styled(Typography)`
  margin-left: 7em;
  padding-right: 7em;
  width: 100%;
  ${breakpoint.down('lg')`
  margin-left: 6em;
  padding-right: 6em;
  `};
  ${breakpoint.down('md')`
  margin-left: 5em;
  padding-right: 0;
  width: 100%;
  `};
  ${breakpoint.down('sm')`
    margin-left: 0;
    padding-right: 0;
  `};
  & h1 {
    font-size: 0;
  }
  & h2 {
    font-size: 2em;
    font-weight: bolder;
    ${breakpoint.down('lg')`
      font-size: 1.5em;
    `};
  }
  & span {
    color: ${colors.purple};
  }

  & section {
    margin-bottom: 12.5%;
  }

  & b {
    margin-top: 1em;
    font-size: 1.125em;
  }

  & ul {
    ${breakpoint.up('sm')`
    padding-left: 5em;
    padding-right: 8em;
    // padding: 8em;
    `}
    & li {
      font-size: 1.5rem;
      margin: 0.5em 0;
    }
  }
`;

const TextBlock = ({ data, testimonialBlockData, langKey }) => {
  const [width, setWidth] = useState(200);
  const [heightHeader, setHeightHeader] = useState(0);
  const [heightIntro, setHeightIntro] = useState(0);
  const [heightTitleIntro, setHeightTitleIntro] = useState(0);

  const updateDimensions = () => {
    const headerNav = document.getElementById('headerNav');
    const heightIntroDim = document.getElementById('introBlock');
    const heightTitleIntroDim = document.getElementById('titleIntroBlock');
    setWidth(window.innerWidth);
    setHeightHeader(headerNav && headerNav.offsetHeight);
    setHeightIntro(heightIntroDim && heightIntroDim.offsetHeight);
    setHeightTitleIntro(
      heightTitleIntroDim && heightTitleIntroDim.offsetHeight
    );
  };

  useEffect(() => {
    const headerNav = document.getElementById('headerNav');
    if (headerNav) {
      updateDimensions();
    }
  }, [heightHeader]);

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);
  const heightBackground = heightHeader + heightIntro + 216;
  const heightTitle = heightTitleIntro + heightHeader + 96;
  return (
    <>
      <Container heightHeader={heightHeader}>
        <StyledTypography>
          <Text dangerouslySetInnerHTML={{ __html: data.html }} />
        </StyledTypography>
        <div>
          {/* <QuoteBlock> */}
          {/*  <img */}
          {/*    src={ */}
          {/*      testimonialBlockData?.imagesSliderQuotes.find( */}
          {/*        img => img.base === 'heineken_experience.png' */}
          {/*      ).childImageSharp.fluid.src */}
          {/*    } */}
          {/*  /> */}
          {/*  <StyledTypography> */}
          {/*    <TestimonialContainer */}
          {/*      dangerouslySetInnerHTML={{ */}
          {/*        __html: testimonialBlockData?.markdownContent[0]?.html, */}
          {/*      }} */}
          {/*    /> */}
          {/*  </StyledTypography> */}
          {/* </QuoteBlock> */}
        </div>
      </Container>
      <SubIntroBackground
        widthWindow={width}
        heightBackground={heightBackground}
        heightTitle={heightTitle}
      />
    </>
  );
};

export default TextBlock;
